import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import catalogueStructure from '../data/catalogueStructure';

function SubLinks({ items, parentSlug, onClose }) {
  return (
    <div className="mt-1 space-y-0.5">
      {items.map(function(sub) {
        return (
          <Link key={sub.slug} to={"/catalogue/" + parentSlug + "/" + sub.slug} onClick={onClose}
            className="flex items-center gap-2 text-xs text-gray-500 hover:text-orange-500 transition-colors py-1 pl-10">
            <span className="text-sm">{sub.emoji}</span>
            <span>{sub.name}</span>
          </Link>
        );
      })}
    </div>
  );
}

function MegaCategory({ cat, expanded, onToggle, onClose }) {
  var headerCls = "flex items-center gap-2 p-3 rounded-xl transition-colors cursor-pointer w-full " + (cat.highlight ? "bg-orange-50 hover:bg-orange-100" : "hover:bg-gray-50");
  var titleCls = "font-semibold text-xs " + (cat.highlight ? "text-orange-600" : "text-gray-900");

  return (
    <div>
      <button onClick={onToggle} className={headerCls}>
        <h4 className={"flex-1 text-left " + titleCls}>{cat.name}</h4>
        <ChevronDown className={"w-3.5 h-3.5 text-gray-400 transition-transform " + (expanded ? "rotate-180" : "")} />
      </button>
      {expanded && <SubLinks items={cat.subcategories} parentSlug={cat.slug} onClose={onClose} />}
    </div>
  );
}

function CatalogueDropdown({ isOpen, onClose }) {
  var [expanded, setExpanded] = useState('');

  if (!isOpen) return null;

  function toggle(slug) {
    setExpanded(expanded === slug ? '' : slug);
  }

  return (
    <div className="hidden lg:block absolute left-0 right-0 bg-white border-t border-gray-100 shadow-xl z-50" data-testid="catalogue-dropdown">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="grid grid-cols-3 lg:grid-cols-6 gap-4">
          {catalogueStructure.map(function(cat) {
            return (
              <MegaCategory
                key={cat.slug}
                cat={cat}
                expanded={expanded === cat.slug}
                onToggle={function() { toggle(cat.slug); }}
                onClose={onClose}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default CatalogueDropdown;
